import { Stack } from "@mui/material";
import { useState } from "react";
import FormInput from "../../molecules/FormInput";
import FormTemplate from "../../templates/FormTemplate";
import { useTranslation } from "react-i18next";
import { FtpSettings } from "../../../services/swagger";

interface FtpSetupProps {
  ftpSettings?: FtpSettings;
  onSubmit: (ftpConfig: FtpSettings) => void;
  onCancel: () => void;
}

export default function FtpSetup(props: FtpSetupProps) {
  const { t } = useTranslation("SetupPage");
  const [username, setUsername] = useState(props.ftpSettings?.username || "");
  const [password, setPassword] = useState(props.ftpSettings?.password || "");
  const [host, setHost] = useState(props.ftpSettings?.host || "");
  const [port, setPort] = useState(props.ftpSettings?.port || 21);
  const [secure, setSecure] = useState(props.ftpSettings?.secure || false);
  const [uploadPath, setUploadPath] = useState(
    props.ftpSettings?.uploadPath || "/",
  );

  const handleSubmit = () => {
    props.onSubmit({
      enabled: true,
      password,
      port,
      secure,
      host,
      username,
      uploadPath,
    });
  };

  return (
    <FormTemplate
      title={t("FtpSetup.FTPSetup")}
      onSubmit={handleSubmit}
      onCancel={props.onCancel}
      cancelButtonText={t("Back")}
      submitButtonText={t("Next")}
      disableHeaderCloseButton
    >
      <Stack spacing={1}>
        <FormInput
          required
          label={t("FtpSetup.Host")}
          placeholder="localhost"
          field="host"
          type="string"
          value={host}
          onChange={(value) => setHost(value as string)}
        />
        <FormInput
          required
          label={t("FtpSetup.Username")}
          field="username"
          type="string"
          value={username}
          onChange={(value) => setUsername(value as string)}
        />

        <FormInput
          required
          label={t("FtpSetup.Password")}
          field="password"
          inputType="password"
          type="string"
          value={password}
          onChange={(value) => setPassword(value as string)}
        />
        <FormInput
          required
          label={t("FtpSetup.Port")}
          field="port"
          type="number"
          value={port}
          onChange={(value) => setPort(value as number)}
        />
        <FormInput
          label={t("FtpSetup.Secure")}
          field="secure"
          type="switch"
          value={secure}
          onChange={(value) => setSecure(value as boolean)}
        />
        <FormInput
          required
          label={t("FtpSetup.UploadPath")}
          field="uploadPath"
          type="string"
          value={uploadPath}
          onChange={(value) => setUploadPath(value as string)}
        />
      </Stack>
    </FormTemplate>
  );
}
